import { withHydrate } from '@relay/react/hooks';
import withRedux from '@helpers/withRedux';
import { useUpdateUrlWithVariant } from './useUpdateUrlWithVariant';
const ProductDetails = () => {
  useUpdateUrlWithVariant();
  return null;
};
export default withHydrate(withRedux(ProductDetails), 'ProductDetails', 'hybrid');
